import { IconComponent } from "@@common";
import { IExpressionEvaluatorContext } from "@@expressions";
import { Button } from "@mui/material";
import React from "react";
import { useComponentSelection } from "../../Hooks/useComponentSelection";
import useObservedExpression from "../../Hooks/useObservedExpression";
import { DialogActionModel } from "../../Models/DialogActionModel";
import { IsDesignMode } from "../../Utils/runtimeDetection";

type DialogActionButtonProps = {
  action: DialogActionModel;
  actionIndex: number;
  viewId: string;
  componentPath: string[];
  loading: boolean;
  disabled: boolean;
  onClick: () => void;
  context: IExpressionEvaluatorContext;
};

const DialogActionButton: React.FC<DialogActionButtonProps> = ({ action, actionIndex, viewId, componentPath, loading, disabled, onClick, context }) => {
  const [disabledByExpression] = useObservedExpression<boolean>(action.Disabled, context, `DialogAction-${actionIndex}`);

  const isDisabled = (disabled || disabledByExpression === true) && !IsDesignMode;

  const selectionProps = useComponentSelection({
    component: {
      Id: `${viewId}-action-${actionIndex}`,
      Type: "DialogAction",
      Layout: {},
    },
    componentPath,
  });

  return (
    <Button
      {...selectionProps}
      variant={action.IsDefault ? "contained" : "outlined"}
      startIcon={action.IconName ? <IconComponent iconName={action.IconName} /> : undefined}
      loading={loading}
      onClick={onClick}
      disabled={isDisabled}
    >
      {action.Label}
    </Button>
  );
};

export default DialogActionButton;
